import { axios, API, SendRequest, toastr, WebsiteCookies } from '@/imports-files/pages/admins/login';

  
export class LoginRequest extends SendRequest {
  async isUserAuthenticated(params) {
    try {
      const result = await axios.post( API.admins.LOGIN_SUBMIT_URL,
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }


  async getUserInfo(params) {
    try {
      const result = await axios.get(API.client.welcome.GET_USER_INFO,
        {params: params},
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async acceptInviteSetPassword(params) {
    try {
      const result = await axios.put(API.client.welcome.ACCEPT_INVITE_SET_PASSWORD,
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());

      return result;
    } catch (error) {
      return error;
    }
  }

}
